import { render, staticRenderFns } from "./RateWidget.vue?vue&type=template&id=62b70c89&scoped=true&"
import script from "./RateWidget.vue?vue&type=script&lang=js&"
export * from "./RateWidget.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62b70c89",
  null
  
)

export default component.exports